module.exports = __webpack_public_path__ + "img/l_googleCP.a3190a0a.svg";